import { render, staticRenderFns } from "./DocEditLink.vue?vue&type=template&id=8976abb2&"
import script from "./DocEditLink.vue?vue&type=script&lang=js&"
export * from "./DocEditLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports